import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { AgGridAngular } from 'ag-grid-angular';
import * as agGrid from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ApiService } from '../../../../api.service';

@Component({
  standalone: false,
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss'],
})
export class BillingComponent {
  @Input() billingId = 0;
  rowData: any = [];
  private prevPageSize: number = 0;
  gridReady = false;
  gridOptions!: agGrid.GridOptions;
  public searchDataValue = '';
  @ViewChild('agGrid') agGrid: AgGridAngular | any;
  public tooltipShowDelay = 0;
  public tooltipHideDelay = 2000;
  @ViewChild('filtertextbox') filtertext!: ElementRef;
  SerachedRow: number | undefined;
  private gridColumnApi: any;
  selectedTabIndex = 0;
  private gridApi: any;
  paginationPageSize = 10;
  pages: number[] = [];
  totalPages: number = 0;
  currentPage: number = 1;
  visiblePageCount = 5;
  startPage = 1;
  fromRecord = 0;
  toRecord = 0;
  totalRecords = 0;
  totalPage: number = 0;
  currPage: number = 0;
  paging: number[] = [];
  lastElementOfPage: number = 0;
  NoRecordsFound!: boolean;

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
  };

  colDefs: ColDef[] = [
    {
      headerName: 'S.NO',
      valueGetter: (params: any) => {
        const rowNode = params.node;
        const model = params.api.getModel();
        const allRows: any[] = [];
        model.forEachNodeAfterFilterAndSort((node: any) => {
          allRows.push(node);
        });
        const globalIndex = allRows.findIndex((node) => node === rowNode);
        return globalIndex + 1;
      },
      flex: 0.5,
      minWidth: 80,
      editable: false,
      resizable: false,
      filter: false,
      sortable: false,
      lockPosition: true,
    },
    {
      headerName: 'Plan Name',
      cellRenderer: (params: any) => {
        const value =
          (params.data?.subBundle?.bundle_name || '') +
          ' ' +
          (params.data?.subPack?.pack_name || '');
        const text = value.trim();

        const span = document.createElement('span');
        span.innerText = text;
        span.title = text;
        return span;
      },
      flex: 1.5,
      minWidth: 130,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Category Name',
      cellRenderer: (params: any) => {
        const value = params.data?.category?.category_name || 'N/A';
        const text = value.trim();

        const span = document.createElement('span');
        span.innerText = text;
        span.title = text;
        return span;
      },
      flex: 1.5,
      minWidth: 170,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Billing Type',
      cellRenderer: (params: any) => {
        const addon = params.data.is_addon;
        let value = 'N/A';
        if (addon === 0) value = 'Main Plan';
        else if (addon === 1) value = 'Additional Category';

        const span = document.createElement('span');
        span.innerText = value;
        span.title = value;
        return span;
      },
      flex: 1,
      minWidth: 150,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'Currency',
      field: 'currency',
      flex: 1,
      minWidth: 100,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      cellStyle: { marginLeft: '-10px' },
    },
    {
      headerName: 'Amount',
      field: 'amount',
      flex: 1,
      minWidth: 100,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      lockPosition: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      cellStyle: { marginLeft: '-10px' },
    },
    {
      headerName: 'Payment Mode',
      valueGetter: (params: any) => {
        const first = params.data?.paymentGateway?.payment_gateway || '';
        return `${first}`.trim();
      },
      flex: 1,
      minWidth: 150,
      editable: false,
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
      cellStyle: { marginLeft: '-10px' },
    },
    {
      headerName: 'Status',
      valueGetter: (params: any) => {
        const id = params.data.subStatus?.sub_status_id;
        if ([1, 15].includes(id)) {
          return 'Active';
        } else if ([9, 4].includes(id)) {
          return 'Failed';
        } else if ([0, 2, 14, 8, 19].includes(id)) {
          return 'In Progress';
        } else if ([20].includes(id)) {
          return 'Deactivated';
        } else {
          return 'Unknown';
        }
      },
      flex: 1,
      minWidth: 150,
      editable: false,
      resizable: true,
      filter: true,
      cellStyle: { marginLeft: '-10px' },
      sortable: true,
      lockPosition: true,
    },
    {
      headerName: 'Last Billed',
      flex: 1,
      minWidth: 150,
      valueGetter: (params: any) => {
        const rawDate = params.data?.last_billing_date;
        if (!rawDate) return 'N/A';
        const date = new Date(rawDate);
        if (isNaN(date.getTime())) return 'N/A';
        return date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          timeZone: 'Africa/Harare',
        });
      },
      editable: false,
      cellStyle: { marginLeft: '-10px' },
      resizable: true,
      filter: true,
      sortable: true,
      comparator: (a: string = '', b: string = '') => a.localeCompare(b),
      lockPosition: true,
    },
    {
      headerName: 'View',
      flex: 0.5,
      minWidth: 100,
      cellRenderer: (params: { data: { feature_name: string } }) => {
        return `
        <img style="cursor:pointer;width:20px; margin-right:10px;" src="assets/img/visual.png" class="visual-icon" title="View">
      `;
      },
      onCellClicked: (params: any) => {
        const target = params.event?.target as HTMLElement;
        if (!target) return;
        if (target.classList.contains('visual-icon')) {
          const serialNo = params.node?.rowIndex + 1;
          this.openVisualPopup(params.data, serialNo);
        }
      },
      lockPosition: true,
      sortable: false,
      resizable: true,
    },
    {
      headerName: 'Download',
      flex: 0.5,
      minWidth: 100,
      cellRenderer: () => `
    <img style="width:20px; margin-right:10px; cursor:pointer;" 
         src="assets/img/download.png" class="download-icon" title="Download">
  `,
      onCellClicked: (params: any) => {
        const target = params.event?.target as HTMLElement;
        if (target && target.classList.contains('download-icon')) {
          this.downloadGridAsPDF(params.data);
        }
      },
      lockPosition: true,
      sortable: false,
      resizable: true,
    },
  ];

  popupData: any;
  popupVisible: boolean = false;
  objectKeys = Object.keys;
  userProfile: any;

  openVisualPopup(data: any, serialNo: any) {
    this.popupData = data;
    this.popupData.serialNo = serialNo;
    this.popupVisible = true;
  }

  closeVisualPopup() {
    this.popupVisible = false;
    this.popupData = null;
  }

  constructor(
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
  ) {
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');

    this.getUserBillingHository(
      this.billingId ? this.billingId : this.userProfile.user_id,
    );
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  downloadGridAsPDF(rowData: any) {
    this.spinner.show();

    const doc = new jsPDF('p', 'pt', 'a4');
    let y = 80;
    const marginX = 60;
    const pageWidth = doc.internal.pageSize.getWidth();
    const lineHeight = 28;
    const fontSize = 14;

    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.text('Billing History', pageWidth / 2, 40, { align: 'center' });

    doc.setFontSize(fontSize);
    doc.setFont('helvetica', 'normal');

    const drawRow = (
      label: string,
      value: string,
      options: { color?: string; icon?: string } = {},
    ) => {
      const labelX = marginX;
      const valueX = pageWidth - marginX - doc.getTextWidth(value) - 20;

      doc.setFont('helvetica', 'bold');
      doc.setTextColor(0, 0, 0);
      doc.text(`${label} -`, labelX, y);

      doc.setFont('helvetica', 'normal');
      const displayValue = options.icon ? `${options.icon} ${value}` : value;

      if (options.color) {
        const [r, g, b] = options.color.split(',').map(Number);
        doc.setTextColor(r, g, b);
      } else {
        doc.setTextColor(0, 0, 0);
      }

      doc.text(displayValue, valueX, y);
      y += lineHeight;
    };

    const statusId = rowData?.subStatus?.sub_status_id;
    let statusText = 'Unknown';
    let statusColor = '0, 0, 0';

    if ([1, 15].includes(statusId)) {
      statusText = 'Active';
      statusColor = '0, 128, 0';
    } else if ([9, 4].includes(statusId)) {
      statusText = 'Failed';
      statusColor = '255, 0, 0';
    } else if ([0, 2, 14, 8, 19].includes(statusId)) {
      statusText = 'In Progress';
      statusColor = '255, 165, 0';
    } else if (statusId === 20) {
      statusText = 'Deactivated';
      statusColor = '128, 128, 128';
    }

    const billedDate =
      rowData?.last_billing_date &&
      rowData.last_billing_date !== 'N/A' &&
      rowData.last_billing_date !== 'null'
        ? new Date(rowData.last_billing_date).toLocaleDateString()
        : 'N/A';

    drawRow(
      'Plan Name',
      `${rowData?.subBundle?.bundle_name || ''} ${
        rowData?.subPack?.pack_name || ''
      }`,
    );
    drawRow('Category Name', rowData?.category?.category_name || 'N/A');
    drawRow(
      'Billing Type',
      rowData?.is_addon === 1
        ? 'Additional Category'
        : rowData?.is_addon === 0
          ? 'Main Plan'
          : 'N/A',
    );
    drawRow('Subscription Type', rowData?.sub_type || 'N/A');
    drawRow('Amount', rowData?.currency || 'N/A');
    drawRow('Payment Mode', rowData?.paymentGateway?.payment_gateway || 'N/A');
    drawRow('Status', statusText, { color: statusColor });
    drawRow('Billed On', billedDate);
    drawRow('Transaction Number', `${rowData?.billing_number || 'N/A'}`);
    drawRow('Transaction ID', `${rowData?.client_trans_id || 'N/A'}`);
    drawRow(
      'Subscribed Via',
      rowData?.subChannel?.channel_name || 'Web / App / USSD / SMS',
    );

    doc.save(`transaction_${rowData?.client_trans_id || 'download'}.pdf`);
    this.spinner.hide();
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Africa/Harare',
    });
  }

  getUserBillingHository(id: any) {
    this.spinner.show();
    this.apiService.getUserBillingHistory(id).subscribe(
      (res: any) => {
        this.rowData = (res.data || [])
          .map((item: any) => {
            return {
              sub_id: item.sub_id ?? 'N/A',
              sub_bundle_id: item.sub_bundle_id ?? 'N/A',
              sub_pack_id: item.sub_pack_id ?? 'N/A',
              start_date: item.start_date ?? 'N/A',
              sub_type: item.sub_type ?? 'N/A',
              last_billing_date: item.last_billing_date ?? 'N/A',
              is_addon: item?.SubsData?.is_addon,
              client_trans_id: item.client_trans_id,
              billing_number: item.billing_number ?? 'N/A',
              renewal_date: item.renewal_date ?? 'N/A',
              payment_gateway_id: item.payment_gateway_id ?? 'N/A',
              currency: item.currency ?? 'N/A',
              sub_phone_number: item.sub_phone_number ?? 'N/A',
              amount: item.amount ?? 'N/A',
              category: item.category,
              subStatus: {
                sub_status_id: item.subStatus?.sub_status_id ?? 'N/A',
                sub_status: item.subStatus?.sub_status ?? 'N/A',
              },

              subBundle: {
                bundle_id: item.subBundle?.bundle_id ?? 'N/A',
                bundle_name: item.subBundle?.bundle_name ?? 'N/A',
                bundle_price: item.subBundle?.bundle_price ?? 'N/A',
              },

              subPack: {
                pack_id: item.subPack?.pack_id ?? 'N/A',
                pack_name: item.subPack?.pack_name ?? 'N/A',
                pack_price: item.subPack?.pack_price ?? 'N/A',
              },

              subChannel: {
                channel_id: item.subChannel?.channel_id ?? 'N/A',
                channel_name: item.subChannel?.channel_name ?? 'N/A',
                created_by_user_id:
                  item.subChannel?.created_by_user_id ?? 'N/A',
                updated_by_user_id:
                  item.subChannel?.updated_by_user_id ?? 'N/A',
              },

              paymentGateway: {
                payment_gateway_id:
                  item.paymentGateway?.payment_gateway_id ?? 'N/A',
                payment_gateway: item.paymentGateway?.payment_gateway ?? 'N/A',
                payment_method: item.paymentGateway?.payment_method ?? 'N/A',
              },
            };
          })
          .sort((a: any, b: any) => {
            const dateA =
              a.last_billing_date === 'N/A'
                ? 0
                : new Date(a.last_billing_date).getTime();
            const dateB =
              b.last_billing_date === 'N/A'
                ? 0
                : new Date(b.last_billing_date).getTime();
            return dateB - dateA;
          });
        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching profile:', err);
        this.spinner.hide();
      },
    );
  }

  reload(data: any) {
    this.getUserBillingHository(this.userProfile.user_id);
  }

  ngOnDestroy() {
    this.gridApi = null;
  }
}
